import { computed, Ref, unref } from 'vue';
import { IMapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import { useState } from 'vuex-composition-helpers';
import _ from 'underscore';
import { wordEnding } from '@ve/services/textModifiers';

const filtersMappingStoreName = 'mapForFilters';

export default ({
                    selectedMeals,
                }: {
    selectedMeals: Ref<number[]>,
}) => {
    const {
        mealsRepository,
    } = useState<IMapForFiltersState>(filtersMappingStoreName, ['mealsRepository']);

    const allowedMealTypes = [7, 5, 3, 2, 10, 1, 8, 11];

    const mealsReference = computed(() => _.filter(unref(mealsRepository), (meal) => !!~allowedMealTypes.indexOf(meal.id)));

    const allMealsChecked = computed({
        get: () => !unref(selectedMeals).length,
        set: (value) => {
            if (value) {
                selectedMeals.value = [];
            }
        },
    });

    const selectedMealsText = computed(() => {
        const selectedMealsValue = unref(selectedMeals);
        if (selectedMealsValue.length === 1) {
            const selectedMeal = unref(mealsReference).find((meal) => meal.id === selectedMealsValue[0]);
            return `${selectedMeal?.code} - ${selectedMeal?.name}`;
        }
        if (selectedMealsValue.length > 4) {
            return `${selectedMealsValue.length} тип${wordEnding(selectedMealsValue.length, ';а;ов')} питания`;
        }
        if (selectedMealsValue.length > 1) {
            return _.pluck(unref(mealsReference).filter((meal) => !!~selectedMealsValue.indexOf(meal.id)), 'code').join(', ');
        }
        return 'Все типы питания';
    });

    return {
        selectedMealsText,
        allMealsChecked,
        selectedMeals,
        mealsReference,
    };
};